import React, { useState } from "react";
import _Button from "../../../generic/_Button";
import _Input from "../../../generic/_Input";
import { useFormikContext, FieldArray } from "formik";
import _Badge from "../../../generic/_Badge";
import ModalAction from "../../../modal/ModalAction";
import PropTypes from "prop-types";

const QuickResponse = (props) => {
  const { carrousel = null } = props;
  const { values, setFieldValue, errors } = useFormikContext();
  const [show, setShow] = useState(false);

  const getBasePath = () => {
    return carrousel !== null
      ? `carrousel.${carrousel}.buttonQuickReplies`
      : "buttonQuickReplies";
  };

  const getCurrentValues = () => {
    return carrousel !== null
      ? values.carrousel?.[carrousel]?.buttonQuickReplies
      : values.buttonQuickReplies;
  };

  const getFieldErrors = (index, field) => {
    if (carrousel !== null) {
      return errors?.carrousel?.[carrousel]?.buttonQuickReplies?.[index]?.[
        field
      ];
    }
    return errors?.buttonQuickReplies?.[index]?.[field];
  };

  const getGeneralError = () => {
    if (carrousel !== null) {
      return errors?.carrousel?.[carrousel]?.buttonQuickReplies;
    }
    return errors?.buttonQuickReplies;
  };

  const basePath = getBasePath();
  const currentValues = getCurrentValues() || [];

  return (
    <>
      <_Badge count={currentValues.length}>
        <_Button
          icon="quickreply"
          style="none"
          className="w-full"
          title="Respuestas rápidas"
          onClick={() => setShow(true)}
        />
      </_Badge>

      <ModalAction
        title="Agregar sugerencias"
        onClose={() => setShow(false)}
        visible={show}
      >
        <div className="flex-grow-1 p-3" style={{ overflowY: "auto" }}>
          <FieldArray
            name={basePath}
            render={({ remove }) => (
              <>
                {currentValues.map((item, index) => (
                  <div
                    key={index}
                    className="border p-2 rounded-md bg-gray-50 mb-2 space-y-2"
                  >
                    <_Input
                      title="Texto del botón"
                      name={`${basePath}.${index}.text`}
                      id={`${basePath}.${index}.text`}
                      value={item.text}
                      placeholder="Texto del botón"
                      onChange={(e) => {
                        setFieldValue(
                          `${basePath}.${index}.text`,
                          e.target.value,
                        );
                      }}
                      errors={getFieldErrors(index, "text")}
                      isError={!!getFieldErrors(index, "text")}
                    />
                    <div className="flex justify-end">
                      <_Button
                        icon="close"
                        style="none"
                        title="Eliminar"
                        onClick={() => remove(index)}
                        type="button"
                      />
                    </div>
                  </div>
                ))}
              </>
            )}
          />
        </div>

        <div className="p-3 bg-white">
          <div className="flex justify-end">
            {typeof getGeneralError() === "string" && (
              <p className="text-red-700 text-sm">{getGeneralError()}</p>
            )}
          </div>
          <div className="mt-3 flex justify-end gap-2 pt-3">
            <_Button
              title="Añadir Botón"
              icon="add"
              style="none"
              type="button"
              disabled={!!getGeneralError()}
              onClick={() => {
                const newButton = {
                  text: "",
                  type: "reply",
                  action: "reply",
                  postback: "",
                };

                const currentArray = getCurrentValues() || [];
                setFieldValue(basePath, [...currentArray, newButton]);
              }}
            />

            <_Button
              style="primary"
              title="Listo"
              icon="check"
              disabled={!!getGeneralError()}
              onClick={() => setShow(false)}
            />
          </div>
        </div>
      </ModalAction>
    </>
  );
};

QuickResponse.propTypes = {
  carrousel: PropTypes.any,
};

export default QuickResponse;
